import { Row, Col, TablePaginationConfig } from 'antd';
import {
  FilterValue,
  SorterResult,
  TableCurrentDataSource,
} from 'antd/lib/table/interface';
import { addProductSubTitle, addProductTitle } from 'constants/constants';
import { AllProductListTableFields } from 'enums/AllProductListEnums';
import { ParentProductList } from 'models/ParentProductList/parentProductList.model';
import React, { FC, useState } from 'react';
import COTable from 'shared/components/COTable';
import EmptyStateComponent from 'shared/components/EmptyStateComponent';
import LoaderAnimation from 'shared/components/LoaderAnimation';
import useRedirect from 'shared/utils/useRedirect';
import { SortingProps } from 'views/OrganisationDetails/LocationDetails';
import AllProductsColumns from './allProducts.columns';
import styles from './productListTable.module.scss';

interface ProductListTableProps {
  filterParams: FetchProductProps;
  updateFilters: (params?: FetchProductProps) => void;
  loading?: boolean;
  parentProducts?: ParentProductList[];
  handleOpenCreateProductModal?: () => void;
}
export interface FetchProductProps {
  page?: number;
  search?: string;
  sortBy?: string;
  sortDir?: string;
}

const ProductListTable: FC<ProductListTableProps> = ({
  filterParams,
  updateFilters,
  loading,
  parentProducts,
  handleOpenCreateProductModal,
}) => {
  const { redirectToChildProducts } = useRedirect();
  const [sortedInfo, setSortedInfo] = useState<SortingProps>({
    columnKey: filterParams?.sortBy ?? '',
    order: filterParams?.sortDir ?? '',
  });

  const handleTableChange = (
    _: TablePaginationConfig,
    __: Record<string, FilterValue | null>,
    sorter: SorterResult<ParentProductList> | SorterResult<ParentProductList>[],
    ___: TableCurrentDataSource<ParentProductList>
  ) => {
    if (sorter) {
      const isSingleSorter = !Array.isArray(sorter);
      const currentSorter = isSingleSorter ? sorter : sorter[0];
      const { columnKey, order } = currentSorter;
      setSortedInfo({
        columnKey:
          columnKey && order
            ? columnKey === AllProductListTableFields.IN_REVIEW
              ? AllProductListTableFields.IN_REVIEW_KEY
              : columnKey
            : undefined,
        order: order,
      });
      updateFilters({
        sortBy:
          columnKey && order
            ? columnKey === AllProductListTableFields.IN_REVIEW
              ? AllProductListTableFields.IN_REVIEW_KEY
              : (columnKey as string)
            : undefined,
        sortDir: order ?? '',
      });
    }
  };

  const handleRowClickHandler = async (row: ParentProductList) =>
    redirectToChildProducts(row?.name);

  return (
    <Row gutter={[0, 20]} className={styles.detailsPage}>
      {parentProducts?.length ? (
        <Col span={24}>
          <COTable
            loading={loading}
            columns={AllProductsColumns({
              sortedInfo,
            })}
            data={parentProducts}
            onChange={handleTableChange}
            handleRowClick={handleRowClickHandler}
          />
        </Col>
      ) : !loading ? (
        <div className={styles.emptyStateContainer}>
          <div onClick={handleOpenCreateProductModal}>
            <EmptyStateComponent
              title={addProductTitle}
              subTitle={addProductSubTitle}
            />
          </div>
        </div>
      ) : (
        <div className={styles.loaderContainer}>
          <LoaderAnimation />
        </div>
      )}
    </Row>
  );
};

export default ProductListTable;
